import { useSidebar } from "@/stores/sidebar";

export default function Hamburger() {
  const open = useSidebar((s) => s.open);
  return (
    <button
      onClick={open}
      className="md:hidden p-1.5 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 cursor-pointer rounded-md hover:bg-gray-100 dark:hover:bg-gray-800"
      title="Открыть панель"
      aria-label="Открыть панель"
    >
      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
      </svg>
    </button>
  );
}
